import { useDispatch, useSelector } from "react-redux";
import { setShowNotification } from "../../actions/notification";
import { Badge } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconComponent from "@CubeComponents/icons";

function NotificationIcon() {
  const { t } = useTranslation();
  const showNotification = useSelector((state) => state.showNotification);
  const unreadNotificationsCount = useSelector((state) => state.unreadNotificationsCount);

  const dispatch = useDispatch();
  const handleClickNotification = () => {
    dispatch(setShowNotification(!showNotification));
  };

  const getNotificationValue = () => {
    if (unreadNotificationsCount.count > 99) {
      return "99+";
    }
    return unreadNotificationsCount.count;
  };

  return (
    <div data-testid="notificationIcon" className="preventNotificationClose flex relative">
      <Badge
        sx={{
          "& .MuiBadge-badge": {
            color: "white",
            backgroundColor: "#6BBBE3",
          },
        }}
        badgeContent={getNotificationValue()}
        max={99}
      >
        <IconComponent
          onClick={handleClickNotification}
          position="bottom"
          toolTipContent={t("Notification")}
          name="BellIcon"
        />
      </Badge>
    </div>
  );
}

export default NotificationIcon;
